// extracted by mini-css-extract-plugin
module.exports = {"select":"SelectObjectives_select__34WIu"};